import { WithReservationStatus } from '@/travelsuit'
import { ReservationStatus } from '@/types/trip'

export function isFailedBooking(withStatus?: Partial<WithReservationStatus>) {
	const status = withStatus?.reservation_status
	return !!status && [ReservationStatus.BookFailed, ReservationStatus.Reverted].includes(status)
}
